export const sm = "(min-width: 30em)"
export const md = "(min-width: 60em)"
export const lg = "(min-width: 75em)"
export const xl = "(min-width: 87.5em)"
